import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7c64e1fc&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c64e1fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2023/thShop/thShopAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c64e1fc')) {
      api.createRecord('7c64e1fc', component.options)
    } else {
      api.reload('7c64e1fc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7c64e1fc&scoped=true&", function () {
      api.rerender('7c64e1fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/active/janActive/index.vue"
export default component.exports